import flyer2 from '../../../assets/img/graphics-works/flyer2.png'
import flyer1 from '../../../assets/img/graphics-works/flyer1.png'
import mockups from '../../../assets/img/graphics-works/mockups.png'
import talent_hunt from '../../../assets/img/graphics-works/talent-hunt.png'
import simulation from '../../../assets/img/graphics-works/web-simulation.png'
import flyer3 from '../../../assets/img/graphics-works/flyer3.png'
import flyer4 from '../../../assets/img/graphics-works/flyer4.png'
import flyer5 from '../../../assets/img/graphics-works/flyer5.png'
import flyer6 from '../../../assets/img/graphics-works/flyer6.png'
import flyer7 from '../../../assets/img/graphics-works/flyer7.png'
import flyer8 from '../../../assets/img/graphics-works/flyer8.png'
import flyer9 from '../../../assets/img/graphics-works/flyer9.png'
import flyer10 from '../../../assets/img/graphics-works/flyer10.png'

import flyer11 from '../../../assets/img/graphics-works/50th-birthday.jpg';
import flyer12 from '../../../assets/img/graphics-works/Artboard1.jpg';
import flyer13 from '../../../assets/img/graphics-works/Artboard2.jpg';
import flyer14 from '../../../assets/img/graphics-works/clive-cloth.png';
import flyer15 from '../../../assets/img/graphics-works/neon-app.jpg';
import flyer16 from '../../../assets/img/graphics-works/okkk.jpg';

import '../../tab/style.css'


const GraphicsContent = () => {
    return (
        <>
            <div className="w-full bg-white mb-12">
                <div className="">
                    <div className="grid projects
                        grid-cols-1 
                        sm:grid-cols-2 
                        md:grid-cols-2 
                        lg:grid-cols-4 gap-6 gap-y-6">

                        <div className='work-done'>
                            <img src={flyer12} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer13} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer14} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer15} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer16} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer11} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={simulation} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer1} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={mockups} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer3} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer5} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer4} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={talent_hunt} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer2} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer6} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer7} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer8} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer9} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={flyer10} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                        <div className='work-done'>
                            <img src={simulation} alt="" width="283px" height="252px" className="object-cover" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GraphicsContent
